import React from "react";
import { Quote } from "lucide-react";

export const HumanAiAmplification = () => {
  return (
    <section
      className="relative w-full overflow-hidden py-20 lg:py-28"
      style={{ backgroundColor: "rgba(247, 250, 253, 1)" }}
    >
      {/* Inline styles for the smooth glowing blue pulse animation */}
      <style>{`
        @keyframes smoothBlueGlow {
          0% {
            opacity: 0.08;
            transform: scale(0.995);
          }
          50% {
            opacity: 0.95;
            transform: scale(1.005);
          }
          100% {
            opacity: 0.08;
            transform: scale(0.995);
          }
        }
        .animate-smooth-blue-glow {
          animation: smoothBlueGlow 5s ease-in-out infinite;
        }
      `}</style>

      <div className="mx-auto max-w-[1440px] px-6 lg:px-[70px]">
        <div className="flex flex-col items-center justify-between gap-12 lg:flex-row lg:gap-8 xl:gap-12">
          
          {/* Left Column: Headlines */}
          <div className="flex flex-col items-start gap-5 lg:max-w-[460px] xl:max-w-[480px]">
            <p className="text-[11.5px] font-bold uppercase tracking-[2.4px] text-[#788EA8]">
              HUMAN + AI. A STRONGER TOMORROW.
            </p>

            <h2 className="text-[28px] sm:text-[32px] md:text-[34px] lg:text-[36px] xl:text-[38px] font-bold leading-[1.18] tracking-tight text-[#0B1528]">
              <span className="block sm:whitespace-nowrap">It’s not about replacing people.</span>
              <span className="block">It’s about amplifying</span>
              <span className="block">what people can achieve.</span>
            </h2>

            <p className="text-[15px] sm:text-[15.5px] leading-[26px] text-[#52667D]">
              Cognitive AI gives your teams better tools, deeper insights and new capabilities — so they can focus on what matters most: creativity, judgement and impact.
            </p>
          </div>

          {/* Center Column: Circular Image with Silky Smooth Blue Glowing Light (Inside White Circle) */}
          <div className="relative flex shrink-0 items-center justify-center p-2 sm:p-4">
            <div className="relative flex items-center justify-center">
              {/* The base circular image provided by user (third PNG) */}
              <img
                src="/images/transform/human-ai-circle.png"
                alt="Human and AI Collaboration"
                className="h-auto w-[320px] sm:w-[390px] lg:w-[420px] xl:w-[440px] select-none object-contain drop-shadow-sm"
                draggable={false}
              />

              {/* The Blue Glow Ring - strictly inside the white circle, smoothly pulsing with zero leak */}
              <img
                src="/images/transform/blue-glow-ring.png"
                alt=""
                aria-hidden
                className="animate-smooth-blue-glow pointer-events-none absolute inset-0 h-full w-full select-none object-contain"
                style={{ willChange: "opacity, transform" }}
                draggable={false}
              />
            </div>
          </div>

          {/* Right Column: Quote Card */}
          <div className="w-full lg:w-auto lg:max-w-[290px] xl:max-w-[310px]">
            <div className="rounded-[22px] bg-[#E2EFFF] p-6 sm:p-7 shadow-sm transition-all duration-300 hover:shadow-md">
              {/* Blue Double Quotes Icon */}
              <div className="flex items-center text-[#2563EB]">
                <Quote className="h-7 w-7 fill-[#2563EB] text-[#2563EB]" />
              </div>

              {/* Quote Content */}
              <p className="mt-4 text-[14.5px] leading-[24px] text-[#1E293B]">
                “Cognitive AI isn’t about removing humans from the business. It’s about putting{" "}
                <span className="font-bold text-[#0F172A]">intelligence everywhere it creates value.</span>”
              </p>

              {/* Attribution */}
              <span className="mt-5 block text-[13px] font-medium text-[#64748B]">
                — The Simpel AI Belief
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HumanAiAmplification;
